export const EntityType = {
  PRIVATE_SEARCH: "private_search",
};

export const QueryKeys = {
  privateSearch: () => [EntityType.PRIVATE_SEARCH, "LIST"],
};
